var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-body"},[_c('h1',[_vm._v("Additional Parts")]),_c('fixed-footer',{class:{'active': true},attrs:{"nextLabel":"Next","nextRoute":"revisit.note","prevRoute":"revisit.repair-parts"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }